import React, { useState, useRef, useEffect } from 'react';
// import { DotsVerticalIcon } from '@heroicons/react/solid'; // Using Heroicons for the icon
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';

const ThreeDotsDropdown = ({ onNotesClick, onCommentsClick, onCopyWeekClick, onCopyDayClick }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown if clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleToggle = (e) => {
    e.stopPropagation(); // Prevent triggering other click events
    setIsOpen(!isOpen);
  };

  const handleNotesClick = (e) => {
    e.stopPropagation();
    onNotesClick();
    setIsOpen(false);
  };

  const handleCommentsClick = (e) => {
    e.stopPropagation();
    onCommentsClick();
    setIsOpen(false);
  };

  const handleCopyWeekClick = (e) => {
    e.stopPropagation();
    if (onCopyWeekClick) {
      onCopyWeekClick();
    }
    setIsOpen(false);
  };
  
  const handleCopyDayClick = (e) => {
    e.stopPropagation();
    if (onCopyDayClick) {
      onCopyDayClick();
    }
    setIsOpen(false);
  };

  return (
    <div className="relative inline-block text-left" ref={dropdownRef}>
      <button
        type="button"
        onClick={handleToggle}
        className="rounded-full text-gray-400 hover:text-gray-600 focus:outline-none"
        aria-expanded={isOpen}
        aria-haspopup="true"
      >
        <span className="sr-only">Open options</span>
        {/* <DotsVerticalIcon className="h-5 w-5" aria-hidden="true" /> */}
        <FontAwesomeIcon icon={faEllipsisV} className="h-5 w-5" aria-hidden="true" />
      </button>

      {isOpen && (
        <div
          className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-10"
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="menu-button"
          tabIndex="-1"
        >
          <div className="py-1" role="none">
            <button
              onClick={handleNotesClick}
              className="text-gray-700 block w-full text-left px-4 py-2 text-sm hover:bg-gray-100"
              role="menuitem"
              tabIndex="-1"
              id="menu-item-0"
            >
              Notes
            </button>
            <button
              onClick={handleCommentsClick}
              className="text-gray-700 block w-full text-left px-4 py-2 text-sm hover:bg-gray-100"
              role="menuitem"
              tabIndex="-1"
              id="menu-item-1"
            >
              Comments
            </button>
            {onCopyWeekClick && (
              <button
                onClick={handleCopyWeekClick}
                className="text-gray-700 block w-full text-left px-4 py-2 text-sm hover:bg-gray-100"
                role="menuitem"
                tabIndex="-1"
                id="menu-item-2"
              >
                Copy Week
              </button>
            )}
            {onCopyDayClick && (
              <button
                onClick={handleCopyDayClick}
                className="text-gray-700 block w-full text-left px-4 py-2 text-sm hover:bg-gray-100"
                role="menuitem"
                tabIndex="-1"
                id="menu-item-3"
              >
                Copy Day
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ThreeDotsDropdown; 